const EVENT_NAME = "elog-sync-state-changed";
const LAST_SYNC_KEY = "elog-last-successful-sync";

const initialOnline = () =>
  typeof navigator === "undefined" ? true : Boolean(navigator.onLine);

let snapshot = {
  online: initialOnline(),
  apiReachable: true,
  state: initialOnline() ? "synced" : "offline",
  queueCount: 0,
  failedCount: 0,
  syncing: false,
  retrying: false,
  lastSuccessfulAt:
    typeof window === "undefined" ? null : window.localStorage.getItem(LAST_SYNC_KEY),
};

export const getSyncState = () => ({ ...snapshot });

export const setSyncState = (patch) => {
  snapshot = { ...snapshot, ...patch };
  if (patch?.lastSuccessfulAt && typeof window !== "undefined") {
    window.localStorage.setItem(LAST_SYNC_KEY, patch.lastSuccessfulAt);
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: getSyncState() }));
  }
  return getSyncState();
};

export const subscribeSyncState = (listener) => {
  if (typeof window === "undefined") return () => {};
  const handler = (event) => listener(event.detail || getSyncState());
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
};

export const syncStateEventName = EVENT_NAME;

